import script from "./ListarTurmas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarTurmas.vue?vue&type=script&setup=true&lang=js"

import "./ListarTurmas.vue?vue&type=style&index=0&id=f2b271d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b271d2"]])

export default __exports__